(function(){
  function toast(msg){var t=document.querySelector('.mb-toast');if(!t)return;t.textContent=msg;t.classList.add('is-on');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('is-on')},2200)}
  function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n})}
  // popup that confirms what went into the cart
  function rupees(p){return '₹'+(p/100).toLocaleString('en-IN',{maximumFractionDigits:2})}
  function esc(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML}
  var pop,popT;
  function closePop(){if(pop){pop.classList.remove('is-on');clearTimeout(popT)}}
  function added(item,cart){
    if(!pop){
      pop=document.createElement('div');pop.className='mb-added';pop.setAttribute('role','dialog');pop.setAttribute('aria-live','polite');pop.setAttribute('aria-label','Added to cart');
      document.body.appendChild(pop);
      pop.addEventListener('click',function(e){if(e.target.closest('[data-pop-close]')){e.preventDefault();closePop()}});
      pop.addEventListener('mouseenter',function(){clearTimeout(popT)});
      pop.addEventListener('mouseleave',function(){popT=setTimeout(closePop,4000)});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')closePop()});
    }
    var img=item.image?item.image+(item.image.indexOf('?')>-1?'&':'?')+'width=160':'';
    pop.innerHTML='<div class="mb-added__top"><span class="ok">✓</span><strong>Added to your cart</strong><button type="button" class="x" data-pop-close aria-label="Close">×</button></div>'+
      '<div class="mb-added__item">'+(img?'<img src="'+esc(img)+'" alt="">':'')+'<div><b>'+esc(item.product_title)+'</b><span>'+item.quantity+' × '+rupees(item.final_price)+'</span></div></div>'+
      '<div class="mb-added__sum"><span>Your cart: '+cart.item_count+(cart.item_count===1?' book':' books')+'</span><b>'+rupees(cart.total_price)+'</b></div>'+
      '<div class="mb-added__btns"><a class="mb-btn mb-btn--line" href="/cart">View cart</a><a class="mb-btn" href="/checkout">Checkout</a></div>'+
      '<a href="#" class="mb-added__more" data-pop-close>Keep shopping</a>';
    pop.classList.add('is-on');
    document.querySelectorAll('.mb-cartbtn').forEach(function(b){b.classList.remove('is-bump');void b.offsetWidth;b.classList.add('is-bump')});
    clearTimeout(popT);popT=setTimeout(closePop,6000);
  }
  // filters: tick a box and the list updates; several boxes in one group can be ticked
  document.querySelectorAll('form[data-mb-filter]').forEach(function(f){
    f.addEventListener('change',function(){
      f.querySelectorAll('input[type=number]').forEach(function(i){if(i.value==='')i.disabled=true});
      f.submit();
    });
  });
  // add to cart without leaving the page
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.matches('form[data-mb-add]'))return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'); if(btn){btn.disabled=true}
    var buyNow=e.submitter&&e.submitter.name==='buy_now';
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){toast(res.j.description||'Could not add to cart');return}
        if(buyNow){window.location.href='/checkout';return}
        return loadCart().then(function(c){if(c)added(res.j,c);document.dispatchEvent(new CustomEvent('mb:cart'))})
      })
      .catch(function(){toast('Could not add to cart')})
      .finally(function(){if(btn){btn.disabled=false}});
  });
  // book cards: once a book is in the cart its "Add to cart" button becomes a stepper (− 2 in cart +)
  var inCart={},cartBusy=false;
  function cardForms(root){return [].slice.call((root||document).querySelectorAll('form[data-mb-add]')).filter(function(f){var q=f.querySelector('input[name=quantity]');return q&&q.type==='hidden'})}
  function paintCards(){
    cardForms().forEach(function(f){
      var id=f.querySelector('input[name=id]').value,c=inCart[id],btn=f.querySelector('.mb-add'),box=f.querySelector('.mb-step');
      if(!btn||btn.disabled&&!c)return;
      if(c){
        if(!box){box=document.createElement('div');box.className='mb-step';box.innerHTML='<button type="button" data-cstep="-1" aria-label="One less">−</button><span aria-live="polite"></span><button type="button" data-cstep="1" aria-label="One more">+</button>';f.appendChild(box)}
        var lab=box.querySelector('span'),t=c.qty+' in cart';if(lab.textContent!==t)lab.textContent=t;if(!btn.hidden)btn.hidden=true;if(box.hidden)box.hidden=false;
      }else{if(btn.hidden)btn.hidden=false;if(box&&!box.hidden)box.hidden=true}
    });
  }
  function loadCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      inCart={};c.items.forEach(function(it){var k=String(it.variant_id);if(inCart[k])inCart[k].qty+=it.quantity;else inCart[k]={qty:it.quantity,key:it.key}});
      setCount(c.item_count);paintCards();return c;
    }).catch(function(){});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-cstep]');if(!b)return;
    e.preventDefault();if(cartBusy)return;
    var f=b.closest('form[data-mb-add]'),id=f.querySelector('input[name=id]').value,c=inCart[id];if(!c)return;
    var step=parseInt(b.getAttribute('data-cstep'),10),box=b.closest('.mb-step');
    cartBusy=true;box.classList.add('is-busy');
    var req=step>0
      ?fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})})
      :fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:c.key,quantity:Math.max(0,c.qty-1)})});
    req.then(function(r){return r.json().then(function(j){if(!r.ok)throw j})})
      .then(function(){if(step<0&&c.qty===1)toast('Removed from cart');return loadCart()})
      .then(function(){document.dispatchEvent(new CustomEvent('mb:cart'))})
      .catch(function(err){toast((err&&err.description)||'Could not update the cart');loadCart()})
      .finally(function(){cartBusy=false;box.classList.remove('is-busy')});
  });
  document.addEventListener('mb:cartdrawn',loadCart);
  window.mbPaintCards=paintCards;
  loadCart();
  // cards added later (search results, shelves that load as you scroll) get painted too
  var paintT;new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){if(ms[i].addedNodes.length){clearTimeout(paintT);paintT=setTimeout(paintCards,80);return}}}).observe(document.body,{childList:true,subtree:true});
  // wishlist: kept on this device until accounts are designed
  var key='mb_wishlist',list=[];
  try{list=JSON.parse(localStorage.getItem(key)||'[]')}catch(e){}
  function paintWish(root){(root||document).querySelectorAll('[data-wish]').forEach(function(b){var on=list.indexOf(b.getAttribute('data-wish'))>-1;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false')})}
  paintWish();
  window.mbPaintWish=paintWish;
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wish]'); if(!b)return;
    var h=b.getAttribute('data-wish'),i=list.indexOf(h);
    if(i>-1){list.splice(i,1);toast('Removed from wishlist')}else{list.push(h);toast('Saved to wishlist')}
    try{localStorage.setItem(key,JSON.stringify(list))}catch(err){}
    paintWish();
  });
  // quantity stepper
  document.querySelectorAll('.mb-qty').forEach(function(q){
    var inp=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
      var v=parseInt(inp.value||'1',10)+(b.dataset.step==='up'?1:-1); var max=parseInt(inp.max||'99',10);
      inp.value=Math.max(1,Math.min(max,v));
    })});
  });
  // sort
  document.querySelectorAll('[data-sort]').forEach(function(s){s.addEventListener('change',function(){
    if(s.hasAttribute('data-mb-live'))return;
    var u=new URL(window.location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');window.location.href=u.toString();
  })});
  // phone filter panel
  document.querySelectorAll('[data-filters-open]').forEach(function(b){b.addEventListener('click',function(){document.querySelector('.mb-filters').classList.add('is-open')})});
  document.querySelectorAll('[data-filters-close]').forEach(function(b){b.addEventListener('click',function(){document.querySelector('.mb-filters').classList.remove('is-open')})});
  // long descriptions
  document.querySelectorAll('[data-clamp]').forEach(function(btn){
    var d=document.getElementById(btn.getAttribute('data-clamp')); if(!d)return;
    if(d.scrollHeight<460){btn.hidden=true;d.classList.remove('is-clamped');return}
    btn.addEventListener('click',function(){d.classList.toggle('is-clamped');btn.textContent=d.classList.contains('is-clamped')?btn.dataset.more:btn.dataset.less});
  });
  // product thumbnails
  document.querySelectorAll('[data-thumb]').forEach(function(t){t.addEventListener('click',function(){var m=document.querySelector('.mb-main-img');if(m){m.src=t.getAttribute('data-thumb');m.removeAttribute('srcset')}})});
  // year tabs
  document.querySelectorAll('[data-tabs]').forEach(function(w){
    var tabs=w.querySelectorAll('[data-tab]');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      tabs.forEach(function(x){var on=x===t;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on?'true':'false')});
      w.querySelectorAll('[data-panel]').forEach(function(pn){pn.hidden=pn.getAttribute('data-panel')!==t.getAttribute('data-tab')});
    })});
    // open on the shopper's own year if they picked one on the account page
    try{var pref=JSON.parse(localStorage.getItem('mb_shelf')||'null');if(pref&&pref.tab){var mine=w.querySelector('[data-tab="'+pref.tab+'"]');if(mine)mine.click()}}catch(e){}
  });
  // recommendations on the book page
  document.querySelectorAll('[data-recs]').forEach(function(box){
    fetch(box.getAttribute('data-recs')).then(function(r){return r.text()}).then(function(html){
      var d=document.createElement('div');d.innerHTML=html;
      var inner=d.querySelector('.shopify-section')||d;
      if(!inner.querySelector('.mb-card'))return;
      box.innerHTML=inner.innerHTML;box.hidden=false;
      paintWish(box);
    }).catch(function(){});
  });
})();
// "Can't find a book" forms also land in the Medallied desk (Book requests) when its address is set
document.addEventListener('submit',function(e){
  var f=e.target;if(!f||!f.matches||!f.matches('[data-finder]'))return;
  var desk=String(window.MB_DESK||'').replace(/\/$/,'');if(!desk)return;
  var g=function(n){var el=f.querySelector('[name="contact['+n+']"]');return el?el.value.trim():''};
  var body={kind:'finder',name:g('name'),phone:g('phone'),email:g('email'),title:g('Book title'),author:g('Author'),ed:g('Edition'),page:location.pathname};
  try{fetch(desk+'/intake',{method:'POST',keepalive:true,headers:{'Content-Type':'text/plain'},body:JSON.stringify(body)}).catch(function(){})}catch(err){}
},true);
